import { GetterTree } from 'vuex'
import { PointOfInterest } from './types'
import { RootState } from '../types'

export const getters: GetterTree<PointOfInterest, RootState> = {
  getPoints: state => {
    return state.filterPoints.sort((a, b) => {
      const x = a.label.toUpperCase(),
        y = b.label.toUpperCase()
      return x == y ? 0 : x > y ? 1 : -1
    })
  },
  getResponseError: state => {
    return state.responseError
  },
  getResponseMessage: state => {
    return state.responseMessage
  },
  getGeocodeResult: state => {
    return state.geocodeResult
  },
  getPointOfInterestGeoCoordinates: state => {
    return state.pointOfInterestGeoCoordinates
  }
}
